import React from "react";
import { Flex, Text } from "@adobe/react-spectrum";
import CallIcon from "../../../assets/callIcon.svg";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

interface HistoryCallButtonProps {
  onClick: () => void;
  className?: string;
}

const HistoryCallButton: React.FC<HistoryCallButtonProps> = ({
  onClick,
  className = "",
}) => {
  const vpnStatus = useSelector(
    (state: RootState) => state.webrtc.isVoiceNetworkAvailable
  );
  const ccpSessionState = useSelector(
    (state: RootState) => state.webrtc.ccpSessionState
  );
  const callId = useSelector((state: RootState) => state.call?.id);
  const voicemailId = useSelector((state: RootState) => state.voicemail?.id);
  const callbackId = useSelector((state: RootState) => state.callback?.id);
  const agentStatus = useSelector((state: RootState) => state.agent?.state?.id);

  let disabled =
    !!callId ||
    !vpnStatus ||
    ccpSessionState !== 4 ||
    voicemailId ||
    callbackId ||
    agentStatus === "AfterCallWork";

  return (
    <button
      aria-label="Call"
      data-testid="call-button"
      onClick={onClick}
      disabled={disabled}
      className={`call-history-action-btn call-history-action-btn-call ${
        disabled ? "call-btn-disabled" : ""
      } ${className}`}
    >
      <Flex alignItems={"center"} justifyContent="center">
        <img src={CallIcon} alt="call icon" />
        <Text marginX={7}>Call</Text>
      </Flex>
    </button>
  );
};

export default HistoryCallButton;
